module.exports = __webpack_public_path__ + "img/safe_tool_06.548f3ea2.jpg";